import './style.scss';

//scroll
const addScrollClass = () => {
  const scrollItems = document.querySelectorAll(".wp-block-ths-blocks-parallax-item");
  const scrollImageItems = document.querySelectorAll(".parallax__inner >.wp-block-group:first-child .wp-block-image");

  if (!scrollItems || !scrollImageItems) return;

  makeObserver();

  function makeObserver() {

    const myOptions = {
      root: null,
      rootMargin: '-50% 0px',
      threshold: '0'
    };

    const myObserver = new IntersectionObserver(myIntersect, myOptions);

    for (let n = 0; n < scrollItems.length; n++) {
      myObserver.observe(scrollItems[n]);
    }

  }


  function myIntersect(entries, myObserver) {
    entries.forEach((entry, n) => {
      const nowElement = entry.target;
      if (entry.isIntersecting) {
        nowElement.classList.add('is-show');
        itemImageActive();

      } else {
        nowElement.classList.remove('is-show');
        itemImageActive();
      }
    });
  }

  const itemImageActive = () => {

    Array.from(scrollItems).forEach((scrollItem) => {

      if (scrollItem.classList.contains('is-show')) {
        const ContentIndex = [].slice.call(scrollItems).indexOf(scrollItem);

        Array.from(scrollImageItems).forEach((scrollImageItem) => {
          const ContentImageIndex = [].slice.call(scrollImageItems).indexOf(scrollImageItem);

          if (ContentIndex === ContentImageIndex) {
            scrollImageItem.classList.add('is-show');
          } else {
            scrollImageItem.classList.remove('is-show');
          }
        })
      }
    })

  }
}
if (window.matchMedia("(min-width: 992px)").matches) {
  addScrollClass();
}


